import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { HelpersService, UserService } from '../../../services';
import { CyclistService } from '../../../services/cyclist.service';
import { BikeService } from '../../../services/bike.service';

@Component({
  selector: 'app-item-transfer',
  templateUrl: './item-transfer.component.html',
  styleUrls: ['./item-transfer.component.scss']
})
export class ItemTransferComponent {

  @Input() user: any;
  @Input() bike: any;
  @Input() bikes: any = [];

  @Output() completed = new EventEmitter<boolean>();

  public cyclists: any = [];
  public results: any = [];
  public searched: boolean = false;
  public loading: boolean = false;

  showCreateCustomer: boolean = false;
  showConfirmTransfer: boolean = false;
  showTransferComplete: boolean = false;

  searchTerm: string = '';
  emailSearchIncomplete = false;
  phoneSearchIncomplete = false;
  private searchSubject = new Subject<string>();
  private searchResultsLength = 50;

  firstName: string = '';
  lastName: string = '';
  mobileNumber: string = '';
  emailAddress: string = '';
  public transferMessage = '';
  destinationCustomer: any = null;
  constructor(private translate: TranslateService,
    private cyclistService: CyclistService,
    private bikeService: BikeService,
    private userService: UserService,
    private helperService: HelpersService) { }

  ngOnInit() {
    console.log('User:', this.user);
    console.log('Bike ID:', this.bike);
    if (this.bikes.length == 0)
      if (this.bike)
        this.bikes.push(this.bike);

    this.searchSubject.pipe(debounceTime(500))
      .subscribe(term =>
        this.searchCustomers(term)
      );

  }

  onSearchChange(event) {
    this.searchSubject.next(event);
  }

  private detectSearchType(search: string): 'email' | 'phone' | 'name' {
    // Email regex pattern
    const hasAtSymbol = search.includes('@');

    // Phone number regex patterns (adjust based on your requirements)
    const phoneRegex = /^[\+]?[\d\s\-\(\)]{4,}$/; // Basic phone pattern

    if (hasAtSymbol) {
      return 'email';
    } else if (phoneRegex.test(search.trim().replace(/[\s\-\(\)]/g, ''))) {
      return 'phone';
    } else {
      return 'name';
    }
  }


  searchCustomers(search: string) {
    this.results = [];
    search = search.trim();
    this.searched = true;
    if (search.length < 4) {
      return;
    }


    const searchType = this.detectSearchType(search);

    this.phoneSearchIncomplete = false;
    this.emailSearchIncomplete = false;

    if (searchType === 'phone' && !this.cyclistService.isValidPhoneNumber(search)) {
      this.phoneSearchIncomplete = true;
      this.results = [];
      return;
    }
    if (searchType === 'email' && !this.cyclistService.isValidEmail(search)) {
      this.emailSearchIncomplete = true;
      this.results = [];
      return;
    }

    this.loading = true;
    this.cyclistService.searchCyclistsV2(this.helperService.getPartnerId(), 0, this.searchResultsLength, search, searchType).subscribe({
      next: (res: any) => {
        this.results = res.cyclists || [];
        this.cyclists = this.results;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error searching customers:', err);
        this.loading = false;
      }
    });
  }

  selectedCustomer(event, customer) {
    event.stopPropagation();
    if (customer.ID === 0) {
      //Create the customer in the PCL
      this.linkStorageAccount(customer);
      this.setTransferMessage();
      return;
    }
    this.destinationCustomer = { ...customer };
    this.setTransferMessage();
    this.searchTerm = "";
    this.results = [];
  }

  linkStorageAccount(customer, edit = false) {
    this.cyclistService.linkCyclists(this.helperService.getPartnerId(), customer).subscribe((response) => {
      if (response && response.Data && response.Data.length > 0) {
        this.destinationCustomer = {
          ID: response.Data[0].ID,
          Name: response.Data[0].CustomerName,
          Surname: response.Data[0].CustomerSurname,
          Email: response.Data[0].CustomerEmail,
          PhoneNumber: response.Data[0].CustomerMobile,
          ExternalID: response.Data[0].ExternalID || 0
        };
        this.setTransferMessage();
        this.searchTerm = "";
        this.results = [];
      } else {
        console.error('Error linking customer:', response);
      }
    }, err => {

    });
  }

  isValidCustomer(): boolean {
    return this.firstName && (this.cyclistService.isValidPhoneNumber(this.mobileNumber) || this.cyclistService.isValidEmail(this.emailAddress));
  }

  createCustomer() {
    if (this.isValidCustomer()) {

      var data = {
        Name: this.firstName,
        Surname: this.lastName,
        Email: this.emailAddress,
        PhoneNumber: this.mobileNumber,
        PartnerID: this.helperService.getPartnerId(),
      };

      this.userService.createCustomerV3(data).subscribe((response) => {

        this.destinationCustomer = {
          ID: response.Data.ID,
          Name: response.Data.CustomerName,
          Surname: response.Data.CustomerSurname,
          Email: response.Data.CustomerEmail,
          PhoneNumber: response.Data.CustomerMobile
        };

        this.setTransferMessage();
        this.firstName = '';
        this.lastName = '';
        this.emailAddress = '';
        this.mobileNumber = '';
        this.showCreateCustomer = false;

      }, (err) => {
        //this.updating = false;
        //var error = err && err.error ? err.error : null;
        //if (error && error.Message == "CUSTOMER_EXISTS" && error.Customer) {
        //  var existingCustomer = {
        //    ID: error.Customer.CyclistID,
        //    Name: error.Customer.CustomerName,
        //    Surname: error.Customer.CustomerSurname,
        //    Email: error.Customer.CustomerEmail,
        //    PhoneNumber: error.Customer.CustomerMobile
        //  }
        //  this.activeModal.close({ action: 'customerExists', existingCustomer: existingCustomer, newCustomer: data });
        //  return
        //}
      });
    }
  }

  transferItem() {
    this.setTransferMessage();
    this.showConfirmTransfer = true;
    //"Transfer $Item.Name$ from $Owner.Name$ to $Customer.Name$? This action cannot be reversed.",


  }

  confirmTransfer() {
    this.showConfirmTransfer = false;
    console.log('Transferring item:', this.bikes);
    console.log('Transferring item from customer:', this.user);
    console.log('Transferring item to customer:', this.destinationCustomer);

    var count = 0;
    this.bikes.forEach(
      bike => {
        var bikeUpdate = bike;
        bikeUpdate.UserID = this.destinationCustomer.ID;
        // Integration fields (e.g. Sports Basement) must survive the copy the old API makes on an owner change.
        // Bikes come from the old API (PascalCase) or the new API (camelCase), so accept either.
        bikeUpdate.ProductID = bike.ProductID ?? bike.productID ?? null;
        bikeUpdate.CustomJson = bike.CustomJson ?? bike.customJson ?? null;
        this.bikeService.saveBike(bikeUpdate).subscribe(
          (updatedBike) => {
            console.log(updatedBike);
            this.bike = updatedBike;
            count++;
            if (count >= this.bikes.length)
              this.showTransferComplete = true;
          },
          (err) => {
          },
        );
      }
    );
  }

  completeTransfer() {
    this.showTransferComplete = false;
    this.completed.emit(true);
  }

  setTransferMessage() {
    this.transferMessage = '';
    this.translate.get('customer.item.edit_item.transfer.confirm_message').subscribe(res => {
      this.transferMessage = res;
      console.log(this.bikes);
      var bikeNames = this.bikes.map(x => x.nickname).join(",");
      this.transferMessage = this.transferMessage.replace("$Item.Name$", bikeNames);
      this.transferMessage = this.transferMessage.replace("$Owner.Name$", this.user.Name);
      this.transferMessage = this.transferMessage.replace("$Customer.Name$", this.destinationCustomer.Name);
    });
  }

  clearPage() {
    this.searchTerm = '';
    this.results = [];
    this.cyclists = [];

    this.loading = false;
    this.searched = false;
    this.destinationCustomer = null;
    this.firstName = '';
    this.lastName = '';
    this.emailAddress = '';
    this.mobileNumber = '';
    this.transferMessage = '';
  }
}
